<div id="admin-menu-body">
    <ng-container>
        <!-- (Group) Integration Sources-->
        <form *ngIf="initControlsFlag" [formGroup]="integrations">
            <div class="form-section" [formGroup]="integrationSettings">
                <!-- Integrations Array -->
                <div class="quickview-label">Integration Settings</div>
                <div class="integration-list form-section clear-float">
                    <div formArrayName="integrationsArray">
                        <div class="integrations">
                            <div
                                *ngFor="
                                    let integration of integrationsArray.controls;
                                    let i = index
                                "
                                class="integration-list-item"
                                [formGroupName]="i"
                            >
                                <fieldset
                                    class="integration-field-set"
                                    [disabled]="this.action == 'View'"
                                >
                                    <input
                                        class="integration-title integration-field"
                                        formControlName="clientIntegrationType"
                                        readonly
                                        matInput
                                    />
                                    <div class="integration-block">
                                        <div class="integration-control">
                                            <div class="recordView-label">
                                                Ingest
                                                {{ integration.get('clientIntegrationType').value }}
                                            </div>
                                            <select
                                                *ngIf="!integration.get('isLoansIngest').value"
                                                class="recordView-input-ddl"
                                                formControlName="ingestSelect"
                                            >
                                                <option
                                                    *ngFor="let val of ['Yes', 'No']"
                                                    [value]="val"
                                                >
                                                    {{ val }}
                                                </option>
                                            </select>

                                            <select
                                                *ngIf="integration.get('isLoansIngest').value"
                                                class="recordView-input-ddl"
                                                formControlName="ingestSelect"
                                            >
                                                <option
                                                    *ngFor="let val of integrationOptions"
                                                    [value]="val"
                                                >
                                                    {{ val }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="integration-description">
                                            {{ getIngestTitle(integration) }}
                                        </div>
                                    </div>
                                    <div
                                        class="integration-block"
                                        *ngIf="integration.get('useZeroPaddedSelect').value == true"
                                    >
                                        <div class="integration-control">
                                            <div class="recordView-label">
                                                Zero Padded Identifier
                                            </div>
                                            <select
                                                class="recordView-input-ddl"
                                                formControlName="zeroPaddedSelect"
                                            >
                                                <option
                                                    *ngFor="let val of ['Yes', 'No']"
                                                    [value]="val"
                                                >
                                                    {{ val }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="integration-description">
                                            {{ getZeroPaddedIdentifierTitle(integration) }}
                                        </div>
                                    </div>
                                    <validator
                                        [control]="integration.get('zeroPaddedSelect')"
                                        [name]="'Zero Padding'"
                                        [topOffset]="0"
                                        [leftOffset]="15"
                                        [bottomOffset]="10"
                                    ></validator>
                                    <div
                                        class="integration-block"
                                        [ngStyle]="{
                                            display:
                                                integration.get('zeroPaddedSelect').value == 'No'
                                                    ? 'none'
                                                    : 'block'
                                        }"
                                    >
                                        <div class="recordView-label">Zero Padded Length</div>
                                        <input
                                            formControlName="zeroPaddedLen"
                                            matInput
                                            class="recordView-input"
                                            [disabled]="
                                                integration.get('zeroPaddedSelect').errors
                                                    ?.zeroPaddingEntityRule
                                            "
                                        />
                                    </div>
                                    <validator
                                        [control]="integration.get('zeroPaddedLen')"
                                        [name]="'Zero Padding Length'"
                                        [topOffset]="0"
                                        [leftOffset]="15"
                                        [bottomOffset]="10"
                                    ></validator>
                                    <div
                                        class="integration-block"
                                        *ngIf="integration.get('useCSExportSelect').value == true"
                                    >
                                        <div class="integration-control">
                                            <div class="recordView-label">
                                                Import from Compensafe
                                            </div>
                                            <select
                                                class="recordView-input-ddl"
                                                formControlName="csExportSelect"
                                            >
                                                <option
                                                    *ngFor="let val of ['Yes', 'No']"
                                                    [value]="val"
                                                >
                                                    {{ val }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="integration-description">
                                            {{ getCSExportTitle(integration) }}
                                        </div>
                                    </div>
                                    <div
                                        class="integration-block"
                                        *ngIf="
                                            integration.get('useXMLExistingSelect').value == true
                                        "
                                    >
                                        <div class="integration-control">
                                            <div class="recordView-label">
                                                Handling for existing records
                                            </div>
                                            <select
                                                class="recordView-input-ddl"
                                                formControlName="xmlExistingSelect"
                                            >
                                                <option
                                                    *ngFor="let val of ['Ignore', 'Update']"
                                                    [value]="val"
                                                >
                                                    {{ val }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="integration-description">
                                            {{ getXMLExistingSelectTitle(integration) }}
                                        </div>
                                    </div>
                                    <input
                                        formControlName="useZeroPaddedSelect"
                                        style="display: none"
                                    />
                                    <input
                                        formControlName="useCSExportSelect"
                                        style="display: none"
                                    />
                                    <input
                                        formControlName="useXMLExistingSelect"
                                        style="display: none"
                                    />
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</div>
<br />
